export interface LotLink {
  id: number
  sourceAccountId: number
  destinationAccountId: number
  outOrigTranId: number
  inOrigTranId: number
  sourceOrigTranId: number
  sourceSecurityId?: number
  destSecurityId?: number
  lotLinkType?: number
  unitsRate?: number
  costBasisProportion: number
}

export interface LotLinkType {
  id: number
  name: string
  exchangeType: string
}

export enum LotLinkTypeEnum {
  UNKNOWN = 'Unknown',
  INTRA_ACCOUNT_TRADE = 'Intra Account Trade',
  EXCHANGE = 'Exchange',
  MERGER = 'Acquisition/Merger',
  SPINOFF = 'Spinoff',
  CASH_STOCK = 'Cash and Stock Acq',
  OTHER_NAIC = 'Other/NAIC',
}

export const lotLinkTypesVal: LotLinkType[] = [
  { id: -1, name: LotLinkTypeEnum.UNKNOWN, exchangeType: 'NORMAL' },
  { id: 1, name: LotLinkTypeEnum.INTRA_ACCOUNT_TRADE, exchangeType: 'NORMAL' },
  { id: 2, name: LotLinkTypeEnum.EXCHANGE, exchangeType: 'NORMAL' },
  { id: 3, name: LotLinkTypeEnum.MERGER, exchangeType: 'MERGER' },
  { id: 4, name: LotLinkTypeEnum.SPINOFF, exchangeType: 'NORMAL' },
  { id: 5, name: LotLinkTypeEnum.CASH_STOCK, exchangeType: 'NORMAL' },
  { id: 6, name: LotLinkTypeEnum.OTHER_NAIC, exchangeType: 'NAIC' },
]

export const tranLinkToLotLinkMap: Map<string, number> = new Map([
  ['IntraAccountLotTransferLotLink', 1],
  ['ExchangeBuisnessActionLotLink', 2],
  ['AcquisitionMergerActionLotLink', 3],
  ['SpinoffActionLotLink', 4],
  ['CashAndStockAquisitionLotLink', 5],
  ['OtherNaicLotLink', 6],
])
